// EVES-3797: Add components and scopes to the permission component scope config
// Author: Abhishek Bharti
// Date: 2025-11-05
export const PermissionComponentScopeConfig: any = {
  "/dashboard": {
    components: ["Dashboard:1.0", "DASH - EVES Summary:1.0"],
    scopes: ["Dashboard:List"],
  },
  "/dashboard/monitoring": {
    components: ["Dashboard:1.0", "DASH - Uptime:1.0"],
    scopes: ["Dashboard:List"],
  },
  "/dashboard/view-trends": {
    components: ["Dashboard:1.0", "DASH - Uptime:1.0"],
    scopes: ["Dashboard:List"],
  },
  "/dashboard/telematics": {
    components: ["Dashboard:1.0", "DASH - Telematics:1.0"],
    scopes: ["Dashboard:List"],
  },
  "/organizations": {
    components: ["Organization Management:1.0", "ORG - Organization:1.0", "ORG - Sites:1.0", "ORG - Sites Areas:1.0"],
    scopes: ["Company:List", "Site:List", "SiteArea:List"],
  },
  "/organizations/companies": {
    components: ["Organization Management:1.0", "ORG - Organization:1.0"],
    scopes: ["Company:List"],
  },
  "/organizations/sites": {
    components: ["Organization Management:1.0", "ORG - Sites:1.0"],
    scopes: ["Site:List"],
  },
  "/organizations/site-areas": {
    components: ["Organization Management:1.0", "ORG - Sites Areas:1.0"],
    scopes: ["SiteArea:List"],
  },
  "/cars": {
    components: ["EV:1.0", "EVM - Connector:1.0"],
    scopes: ["Car:List", "CarCatalog:List"],
  },
  "/cars/electric-vehicles": {
    components: ["EV:1.0", "EVM - Connector:1.0"],
    scopes: ["Car:List", "ElectricVehicle:List"],
  },
  "/cars/catalogs": {
    components: ["EV:1.0", "EVM - Connector:1.0"],
    scopes: ["Car:List", "CarCatalog:List"],
  },
  "/users": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:List"],
  },
  "/users/user-lists": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:List"],
  },
  "/users/user-in-error": {
    components: ["User Administration:1.0", "USR - User:1.0", "Error Report:1.0"],
    scopes: ["User:List"],
  },
  "/logs": {
    components: ["Log Management:1.0", "LM - Basic Application Logs (Feed):1.0"],
    scopes: ["Logging:List"],
  },
  "/profile": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/profile/user-profile": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/profile/notifications": {
    components: [
      "User Administration:1.0",
      "USR - User:1.0",
      "USR - Notification Management & Notification Log Dashboard:1.0",
    ],
    scopes: ["User:Update"],
  },
  "/profile/address": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/profile/security": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/profile/connections": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/profile/miscs": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/profile/billing": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["User:Update"],
  },
  "/tenants": {
    components: [],
    scopes: ["Tenant:List"],
  },
  "/charging-stations": {
    components: ["Charging Station Management:1.0", "CSM - Real-time station status:1.0"],
    scopes: ["ChargingStation:List"],
  },
  "/charging-stations/charging-stations-list": {
    components: ["Charging Station Management:1.0", "CSM - Real-time station status:1.0"],
    scopes: ["ChargingStation:List"],
  },
  "/charging-stations/charging-plans": {
    components: ["Charging Station Management:1.0", "Charging Plan:1.0"],
    scopes: ["ChargingStation:List"],
  },
  "/charging-stations/charging-in-error": {
    components: ["Charging Station Management:1.0", "CSM - Charger Errors/Alerts:1.0", "Error Report:1.0"],
    scopes: ["ChargingStation:List"],
  },
  "/charging-stations/new-charging-stations-list": {
    components: ["Charging Station Management:1.0", "CSM - On-Boarding and Configuration:1.0"],
    scopes: ["ChargingStation:List"],
  },
  "/charging-stations/onboard-new-station": {
    components: ["Charging Station Management:1.0", "CSM - On-Boarding and Configuration:1.0"],
    scopes: ["ChargingStation:List"],
  },
  "/assets": {
    components: ["EVM - Assets:1.0"],
    scopes: ["Asset:List"],
  },
  "/assets/assets": {
    components: ["EVM - Assets:1.0"],
    scopes: ["Asset:List"],
  },
  "/assets/assets-in-error": {
    components: ["EVM - Assets:1.0", "Error Report:1.0"],
    scopes: ["Asset:List"],
  },
  "/energy-storage": {
    components: ["Energy Storage Management:1.0", "EVM - Assets:1.0"],
    scopes: ["Asset:List"],
  },
  "/energy-storage/charging-stations-list": {
    components: ["Energy Storage Management:1.0", "EVM - Assets:1.0"],
    scopes: ["Asset:List"],
  },
  "/energy-storage/charging-plans": {
    components: ["Energy Storage Management:1.0", "EVM - Assets:1.0"],
    scopes: ["Asset:List"],
  },
  "/energy-storage/charging-in-error": {
    components: ["Energy Storage Management:1.0", "EVM - Assets:1.0", "Error Report:1.0"],
    scopes: ["Asset:List"],
  },
  "/energy-storage/onboard-new-station": {
    components: ["Energy Storage Management:1.0", "EVM - Assets:1.0"],
    scopes: ["Asset:List"],
  },
  "/transactions": {
    components: ["Transactions:1.0", "Session Management:1.0", "SSM - Session Management:1.0"],
    scopes: ["Transaction:List"],
  },
  "/transactions/in-progress": {
    components: [
      "Transactions:1.0",
      "Session Management:1.0",
      "SSM - Session Management:1.0",
      "PRM - Session In Progress:1.0",
    ],
    scopes: ["Transaction:List"],
  },
  "/transactions/history": {
    components: ["Transactions:1.0", "Session Management:1.0", "SSM - Session Management:1.0"],
    scopes: ["Transaction:List"],
  },
  "/transactions/in-error": {
    components: [
      "Transactions:1.0",
      "Session Management:1.0",
      "SSM - Session Management:1.0",
      "SSM -  Error Logs:1.0",
      "Error Report:1.0",
    ],
    scopes: ["Transaction:List"],
  },
  "/transactions/refund": {
    components: ["Transactions:1.0", "FSM - Refunding:1.0"],
    scopes: ["Transaction:List"],
  },
  "/gridify": {
    components: ["Gridify:1.0", "PRM - Charger Configuration:1.0"],
    scopes: ["Gridify:GetChargerConfiguration"],
  },
  "/gridify/in-progress": {
    components: ["Gridify:1.0", "PRM - Session In Progress:1.0"],
    scopes: ["Transaction:List"],
  },
  "/gridify/demand-view": {
    components: [
      "Gridify:1.0",
      "PRM - Demand View:1.0",
      "Static Limit:1.0",
      "Demand Management:1.0"
    ],
    scopes: ["Gridify:GetDemandViewData"],
  },
  "/gridify/power-management": {
    components: [
      "Gridify:1.0",
      "PRM - Grid Manager:1.0",
      "Phase Balancing:1.0",
      "Microgrid Controller:1.0",
      "Automated Demand Response (ADR):1.0",
      "PRM - Static Limitation:1.0",
    ],
    scopes: ["Gridify:GetPowerManagement"],
  },
  "/gridify/power-logic": {
    components: [
      "Gridify:1.0",
      "PRM - Grid Manager:1.0",
      "Phase Balancing:1.0",
      "Microgrid Controller:1.0",
      "Automated Demand Response (ADR):1.0",
      "PRM - Static Limitation:1.0",
    ],
    scopes: ["Gridify:GetPowerManagement"],
  },
  "/gridify/charger-configuration": {
    components: ["Gridify:1.0", "PRM - Charger Configuration:1.0"],
    scopes: ["Gridify:GetChargerConfiguration"],
  },
  "/gridify/in-error": {
    components: ["Gridify:1.0", "Error Report:1.0"],
    scopes: ["Gridify:List"],
  },
  "/tags": {
    components: ["Driver Management:1.0", "DM - Tap to charge (RFID, NFC):1.0"],
    scopes: ["Tag:List", "Tag:Update"],
  },
  "/tags/tags-list": {
    components: ["Driver Management:1.0", "DM - Tap to charge (RFID, NFC):1.0"],
    scopes: ["Tag:List"],
  },
  "/tags/expiring-tags-list": {
    components: ["Driver Management:1.0", "DM - Tap to charge (RFID, NFC):1.0"],
    scopes: ["Tag:List"],
  },
  "/integration-settings": {
    components: [],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/roaming": {
    components: ["INT - Roaming (OCPI):1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/roaming-hubject": {
    components: ["INT - Hubject Open Intercharge Protocol (OICP):1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/refunding": {
    components: ["FSM - Refunding:1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/pricing": {
    components: ["FSM - Pricing (Setup and Schedule):1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/billing": {
    components: ["FSM - Invoicing & Processing Fee:1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/analytics": {
    components: ["Reports/Analytics:1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/smartCharging": {
    components: ["PRM - Demand View:1.0", "Static Limit:1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/carConnector": {
    components: ["EVM - Connector:1.0"],
    scopes: ["Setting:Update"],
  },
  "/integration-settings/asset": {
    components: ["EVM - Assets:1.0"],
    scopes: ["Setting:Update"],
  },
  "/technical-settings": {
    components: [],
    scopes: ["Setting:Create"],
  },
  "/technical-settings/crypto-settings": {
    components: [],
    scopes: ["Setting:Create"],
  },
  "/technical-settings/user-settings": {
    components: ["User Administration:1.0", "USR - User:1.0"],
    scopes: ["Setting:Create"],
  },
  "/charging-station-templates": {
    components: [],
    scopes: ["Tenant:List"],
  },
  "/charging-station-templates/charging-station-templates-list": {
    components: [],
    scopes: ["Tenant:List"],
  },
  "/invoices": {
    components: ["Financials:1.0", "FSM - Invoicing & Processing Fee:1.0"],
    scopes: ["Invoice:List"],
  },
  "/invoices/invoice-lists": {
    components: ["Financials:1.0", "FSM - Invoicing & Processing Fee:1.0"],
    scopes: ["Invoice:List", "InvoiceList:List"],
  },
  "/invoices/transfers": {
    components: ["Financials:1.0", "Transfers:1.0"],
    scopes: ["Invoice:List", "TransferList:List"],
  },
  "/invoices/in-transactions": {
    components: ["Financials:1.0", "Transactions:1.0"],
    scopes: ["Invoice:List", "TransferList:List"],
  },
  "/invoices/refund": {
    components: ["Financials:1.0", "FSM - Refunding:1.0"],
    scopes: ["Invoice:List", "TransferList:List"],
  },
  "/invoices/in-errors": {
    components: ["Financials:1.0", "FSM - Invoicing & Processing Fee:1.0", "Error Report:1.0"],
    scopes: ["Invoice:List"],
  },
  "/statistics": {
    components: ["Reports/Analytics:1.0"],
    scopes: ["Setting:Read"],
  },
  "/statistics/consumption": {
    components: ["Reports/Analytics:1.0", "RPT - Consumption (kWh):1.0"],
    scopes: ["Setting:Read"],
  },
  "/statistics/usage": {
    components: ["Reports/Analytics:1.0", "RPT - Usage (hours):1.0"],
    scopes: ["Setting:Read"],
  },
  "/statistics/inactivity": {
    components: ["Reports/Analytics:1.0", "RPT - Inactivity:1.0"],
    scopes: ["Setting:Read"],
  },
  "/statistics/transactions": {
    components: ["Reports/Analytics:1.0", "RPT - Sessions:1.0"],
    scopes: ["Setting:Read"],
  },
  "/statistics/pricing": {
    components: ["Reports/Analytics:1.0", "RPT - Financial:1.0"],
    scopes: ["Setting:Read"],
  },
};
